import { useLocation } from "react-router-dom";
import React from "react";
import { useCart } from "../context/CartContext";

const ProductSingleCard = ({ product }) => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { addToCart, removeFromCart, cartItems } = useCart();

  const itemInCart = cartItems.find((item) => item._id === product._id);

  const quantity = itemInCart ? itemInCart.quantity : 0;

  const isGift = product.tags.toLowerCase().includes("brinde");

  const handleAddToCart = () => {
    addToCart(product);
  };

  const handleRemoveFromCart = () => {
    removeFromCart(product._id);
  };
  return (
    <div className="card-compact w-92 bg-base-200 rounded-sm shadow-xl">
      <figure>
        {isGift ? (
          <img
            src={product.image}
            alt={product.name}
            className="w-[400px] h-[500px] object-cover object-top"
          />
        ) : (
          <img
            src={product.imageSample}
            alt={product.name}
            className="w-[400px] h-[500px] object-cover object-top"
          />
        )}
      </figure>
      {isHome ? null : (
        <>
          <div className="bg-base-300 pt-[4px] text-[12px] font-thin pr-4 pb-1 text-end">
            {product.evento}
          </div>
          {isGift ? null : (
            <div className="flex justify-between items-center bg-base-300 p-4 pt-1">
              <div className="price text-2xl font-semibold">
                R$
                {(product.priceInCents / 100).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </div>

              <div className="card-actions">
                {quantity > 0 ? (
                  <button
                    className="btn btn-error"
                    onClick={handleRemoveFromCart}
                  >
                    Remover do carrinho
                  </button>
                ) : (
                  <button
                    className="btn btn-primary bg-blue-500 border-none"
                    onClick={handleAddToCart}
                  >
                    Quero
                  </button>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default ProductSingleCard;
